


















































































import { Component, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import vSelect from 'vue-select';
import { required } from 'vuelidate/lib/validators';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import OrgPicker from '@/components/orgPicker.vue';
import Toast from '@/components/display/toast.vue';
import { User, UsersApi } from '../../../api';
import { OrdwayService } from '@/services/ordway-service';
import UserPhoneInput from '@/components/form pickers/UserPhoneInput.vue';
import { PhoneNumberDetails } from '@/models/phone-number-details';

@Component({
	components: {
		secondaryNav,
		vSelect,
		OrgPicker,
		Toast,
		UserPhoneInput,
	},
	validations: {
		form: {
			org: {},
			name: { required },
			email: { required },
			password: {},
			// role: {},
		},
	},
	mixins: [validationMixin],
})
export default class UserUpdate extends Vue {
	public form = {
		org: {},
		name: '',
		email: '',
		phone: '',
	};
	public options = [
		{ value: 'org.admin', text: 'Org Administrator' },
		{ value: 'org.user', text: 'Org User' },
	];

	public user: any | null = null;
	public roles: any | null = true;
	public phoneValid: boolean = true;

	public $bvToast: any;
	public loading = true;
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;
	private api: UsersApi;

	constructor() {
		super();
		this.api = new UsersApi();
	}

	public onPhoneChanged(params: { phone: string; phoneObject: PhoneNumberDetails }): void {
		if (params.phoneObject.valid === true) {
			this.phoneValid = true;
			const { countryCallingCode, nationalNumber } = params.phoneObject;
			this.form.phone = `+${countryCallingCode} ${nationalNumber}`;
			return;
		} else if (params.phone === '') {
			this.phoneValid = true;
			this.form.phone = null;
		} else {
			this.phoneValid = false;
		}
	}

	public async onSubmit(e: Event) {
		e.preventDefault();
		this.$v.$touch();
		if (this.$v.$invalid || this.phoneValid === false) {
			this.submitStatus = 'ERROR';
			return;
		}
		this.submitStatus = 'PENDING';

		const { userId } = this.$route.params;
		const user: User = this.form;
		// user.orgId = this.form.org.id;

		let response;

		try {
			response = await new UsersApi().updateUser(parseInt(userId, 10), { data: user });
		} catch (e) {
			let error;
			if (e.response) {
				if (e.response.data.errors.phone) {
					error = 'user not created ' + e.response.data.errors.phone;
				} else if (e.response.data.errors.email) {
					error = 'user not updated ' + e.response.data.errors.email;
				} else {
					error = 'user not updated, unknown response error';
				}
			} else if (e.request) {
				error = 'user not updated, network Error';
				console.log(e.request);
			} else {
				error = 'user not updated, unknown Error';
			}
			// const error = e.response.data.errors.name[0];
			new Toast().makeToast(error, 'Error Updating User', 'danger', true);
			this.submitStatus = 'ERROR';
			return;
		}

		try {
			await OrdwayService.updateOrdwayContact({ ...user, id: this.user.id });
		} catch (error) {
			new Toast().makeToast(
				error,
				'Error updating Ordway Contact - please retry (click save again), or let the software team know.',
				'danger',
				true,
			);
			this.submitStatus = 'ERROR';
			return;
		}

		new Toast().makeToast('User Updated', 'Successfully Updated', 'success');
		this.submitStatus = 'OK';

		setTimeout(() => {
			this.$router.push({ name: 'users.view', params: { userId } });
		}, 1000);
	}

	public async load() {
		const { userId } = this.$route.params;
		this.loading = true;
		try {
			const response = await this.api.getUserId(parseInt(userId, 10), {
				params: { include: 'org,roles' },
			});
			const user: User = response.data;
			// this.form.org = user.org;
			this.form.name = user.name;
			this.form.email = user.email;
			this.form.phone = user.phone;
			// this.roles = user.roles[0];
			// this.form.role = user.roles[0].name;
			this.user = user;
		} catch (e) {
			console.log(e);
			this.user = null;
		} finally {
			this.loading = false;
		}
	}

	public created() {
		this.load();
	}
}
